import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import RouteManager from "../../managers/RouteManager";
import AppManager from "../../managers/AppManager";
import PaymentLogService from "../../services/PaymentLogService";
import Utility from "../../utility/Utility";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import { parseColumnConfig, parseVisibleColumnConfig, PaymentLogsColumnConfig } from "../configs/config";
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../managers/TableManger";
import AttachmentService from "../../services/AttachmentService";
import { saveAs } from 'file-saver';
import {
    showLoader,
    removeLoader,
} from "deskera-ui-library";

function PaymentLogs(props) {
    const history = useHistory();
    const { t } = useTranslation();

    const initialGridData = {
        columnData: [],
        rowData: [],
        originalData: [],
        filter: []
    };
    const [paymentLogs, setPaymentLogs] = useState(null);
    const [gridData, setGridData] = useState(initialGridData);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPageCount, setTotalPageCount] = useState(0);

    useEffect(() => {
        RouteManager.setPresenter({ props: { ...props, history: history } });
        AppManager.scrollToTop();

        getPaymentLogs();
    }, []);

    useEffect(() => {
        if (!Utility.isEmptyObject(paymentLogs)) {
            const { content, number, totalPages } = paymentLogs;
            const rowData = PaymentLogsColumnConfig(content);
            const columnConfig = parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableColumns(TABLES.PEOPLE_PAYMENT_LOGS), TABLES.PEOPLE_PAYMENT_LOGS, {}));

            const gridData = {
                columnData: columnConfig,
                rowData: rowData,
                originalData: rowData,
                filter: []
            };

            setGridData(gridData);
            setCurrentPage(number + 1);
            setTotalPageCount(totalPages);
        }
    }, [paymentLogs]);

    const getPaymentLogs = () => {
        const params = {
            limit: 10,
            page: 0,
            sort: "createdAt",
            sortDir: "desc"
        };

        PaymentLogService.getPaymentLogs(params).then(
            (response) => {
                if (response) {
                    setPaymentLogs(response);
                }
            }, (error) => {

            }
        );
    }

    const downloadGIROFile = (data) => {
        showLoader("Downloading file...");
        AttachmentService.getPresignedURL(data.filePath).then(
            (response) => {
                AttachmentService.downloadFile(response).then(
                    (response) => {
                        removeLoader();
                        saveAs(response, data.fileName);
                    },
                    (error) => {
                        removeLoader();
                    }
                );
            },
            (error) => {
                removeLoader();
            }
        );
    }

    return (
        <div className="parent-height">
            <DataGridHolderPayroll
                tableName={TABLES.PEOPLE_PAYMENT_LOGS}
                displayTableName={TABLE_DISPLAY_NAME[TABLES.PEOPLE_PAYMENT_LOGS]}
                allowBulkOperation={false}
                allowColumnEdit={false}
                allowColumnDelete={false}
                allowColumnShift={false}
                allowSearch={false}
                allowFilter={false}
                allowColumnAdd={false}
                allowRowAdd={false}
                allowColumnSort={false}
                allowDataExport={false}
                allowRowEdit={false}
                showContextEdit={false}
                isActionEnabled={true}
                gridData={gridData}
                currentPage={currentPage}
                totalPageCount={totalPageCount}
                onDownloadAttachment={(data) => {
                    downloadGIROFile(data.rowData.data);
                }}
                onPaginationClick={(requestedPageNumber) => {
                    setCurrentPage(requestedPageNumber);
                }}
            />
        </div>
    );
}

export default PaymentLogs;